import { useEffect } from "react";
import FieldGroup from "../../FieldGroup/FieldGroup";
import ColorPicker from "../../ColorPicker/ColorPicker";
import Checkbox from "../../Checkbox/Checkbox";
import { useContext } from "react";
import { ConfigurationContext, DispatchContext } from "./ConfigurationContext";
import {
  isCheckboxSelected,
  isLidCoverDisabled,
  isLinerColorDisabled,
  isLinerDisabled,
  isSeatingDisabled,
} from "./utils";
import {isWoodDisabled} from "./utils";

const FormStepInteriorExterior = ({
  woodField,
  woodTreatmentField,
  linerField,
  linerColorField,
  lidCoverField, electricalField,
  seatingField,
}) => {
  const {
    size,
    heaters: { heater, upgrades },
    accessories: {electrical},
    interiorexterior: { wood, woodTreatment, liner, linerColor, seating, lidCover },
  } = useContext(ConfigurationContext);
  const dispatch = useContext(DispatchContext);

  const handleWoodChange = (option) => {
    dispatch({ type: "SELECT_WOOD", payload: option });
  };

  const handleWoodTreatmentChange = (option, checked) => {
    dispatch({ type: "SELECT_WOOD_TREATMENT", payload: { option, checked } });
  };

  const handleLinerChange = (option, checked) => {
    dispatch({ type: "SELECT_LINER", payload: { option, checked, wood, woodOptions: woodField.options} });
  };

  const handleLinerColorChange = (option) => {
    dispatch({ type: "SELECT_LINER_COLOR", payload: option });
  };

  const handleLidCoverChange = (option) => {
    dispatch({ type: "SELECT_LID_COVER", payload: option });
  };

  const handleSeatingChange = (option) => {
    dispatch({ type: "SELECT_SEATING", payload: option });
  };

  const woodGroupId = `${woodField.name}-radio-group`;
  const woodTreatmentGroupId = `${woodTreatmentField.name}-group`;
  const linerGroupId = `${linerField.name}-group`;
  const linerColorGroupId = `${linerColorField.name}-group`;
  const lidCoverGroupId = `${lidCoverField.name}-group`;
  const seatingGroupId = `${seatingField.name}-group`;

  useEffect(() => {
    dispatch({ type: "SELECT_WOOD", payload: woodField.options[0] });
    dispatch({
      type: "SELECT_LINER_COLOR",
      payload: linerColorField.options[0],
    });
  }, [dispatch, woodField, linerColorField]);

  useEffect(() => {
    if ((!liner || liner.length === 0) && electrical && electrical[0]?.price !== 210) {
      dispatch({ type: "SELECT_ELECTRICAL", payload: {option: electricalField.options[0], checked: false} });
    }
  }, [liner])

  return (
    <>
      {size?.id !== 3 && (
          <FieldGroup title={linerField.title} id={linerGroupId}>
            {linerField.options.map((option) => (
                <Checkbox
                    key={option.id}
                    name={linerGroupId}
                    isChecked={isCheckboxSelected(option, liner) || (!isLinerDisabled(option, wood) && isCheckboxSelected(option, liner))}
                    {...option}
                    onChange={handleLinerChange}
                />
            ))}
          </FieldGroup>
      )}
      <FieldGroup
        title={woodField.title}
        id={woodGroupId}
        details={woodField.details}
      >
        <ColorPicker
          options={woodField.options}
          selectedOption={wood}
          disableColorCondition={(option) => isWoodDisabled(option, liner, size)}
          onChange={handleWoodChange}
          fieldId={woodGroupId}
        />

        {woodTreatmentField.options.map((option) => (
          <Checkbox
            key={option.id}
            name={woodTreatmentGroupId}
            isChecked={isCheckboxSelected(option, woodTreatment)}
            {...option}
            onChange={handleWoodTreatmentChange}
          />
        ))}
      </FieldGroup>

      <FieldGroup
        title={linerColorField.title}
        id={linerColorGroupId}
        isDisabled={isLinerColorDisabled(liner, size)}
      >
        <ColorPicker
          options={linerColorField.options}
          selectedOption={!isLinerColorDisabled(liner, size, wood) && linerColor}
          onChange={handleLinerColorChange}
          isDisabled={isLinerColorDisabled(liner, size, wood)}
          fieldId={linerColorGroupId}
        />
      </FieldGroup>
      {size?.id !== 3 && (
      <FieldGroup title={seatingField.title} id={seatingGroupId} isDisabled={isSeatingDisabled(liner, size)}>
        {seatingField.options.map((option) => (
          <Checkbox
            key={liner && liner.length > 0 ? option.id : option.id === 1}
            name={seatingGroupId}
            type="radio"
            isChecked={liner && liner.length > 0 ? seating?.id === option.id : option.id === 1}
            {...option}
            isDisabled={isSeatingDisabled(liner, option, wood)}
            onChange={handleSeatingChange}
          />
        ))}
      </FieldGroup>
      )}
      <FieldGroup
        title={lidCoverField.title}
        details={lidCoverField.details}
        id={lidCoverGroupId}
      >
        {lidCoverField.options.map((option) => (
          <Checkbox
            key={option.id}
            type="radio"
            name={lidCoverGroupId}
            isChecked={lidCover?.id === option.id}
            isDisabled={isLidCoverDisabled(option, size, heater, upgrades)}
            {...option}
            onChange={handleLidCoverChange}
          />
        ))}
      </FieldGroup>
    </>
  );
};

export default FormStepInteriorExterior;
